<div class="spinner-modal-overlay" role="dialog" aria-modal="true" aria-live="polite" [attr.aria-label]="primaryMessage">
  <div class="spinner-modal-container">
    <bpt-progress-spinner 
      [value]=75 
      [mode]="spinnerMode" 
      [strokeWidth]=3 
      [diameter]=40
      [animationDuration]="animationDuration">
    </bpt-progress-spinner>
    
    <div class="spinner-message-wrapper" *ngIf="message">
      <div class="spinner-primary-message">{{ primaryMessage }}</div>
      <div class="spinner-secondary-message" *ngIf="secondaryMessage">{{ secondaryMessage }}</div>
    </div>
  </div>
</div>